import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Effect that handles retrying failed messages
 */
export const retryMessage = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.retryMessage.request.observe().pipe(
      rxjs.switchMap(request =>
        plugin.collection.feature.selectors.context.asObservable.pipe(
          rxjs.take(1),
          rxjs.filter(TypeChecker.isNotNullish.raw),
          rxjs.switchMap(context =>
            plugin.api.retryMessage(context, request.data).pipe(
              rxjs.map(() =>
                feature.actions.retryMessage.success
                  .from('retryMessage (effect)')
                  .create({ input: request.data }),
              ),
              rxjs.catchError((error: Error) =>
                rxjs.of(
                  // As with sending: the retried turn outlasts AppSync's 30
                  // seconds while carrying on to completion, and its outcome
                  // arrives through the conversation's subscriptions.
                  graphql.GraphqlResultError.isExecutionTimeout(error)
                    ? feature.actions.retryMessage.success
                        .from('retryMessage (effect)')
                        .create({ input: request.data })
                    : feature.actions.retryMessage.error
                        .from('retryMessage (effect)')
                        .create({
                          error,
                          input: request.data,
                        }),
                ),
              ),
            ),
          ),
        ),
      ),
    ),
)
